import { IsNumber, IsNumberString } from 'class-validator';

/**
 * The DTO of the vacancy copy
 */
export class VacancyCopyDto {
  @IsNumber()
  vacancyId: number;
}
